import { Reveal } from "./Reveal";

const pillars = [
  {
    n: "01",
    title: "Sound Healing",
    desc: "Immersive sound baths with crystal bowls, gongs and chimes that recalibrate the nervous system.",
    img: "https://images.unsplash.com/photo-1595387494697-6325093cc9b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxzb3VuZCUyMGJhdGglMjBzaW5naW5nJTIwYm93bHN8ZW58MHx8fHwxNzgyODM5NDI1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "02",
    title: "Guided Yoga",
    desc: "Reconnect with your body through slow, intentional flows led by experienced teachers.",
    img: "https://images.unsplash.com/photo-1758797315487-b3b225dff7d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHx5b2dhJTIwbmF0dXJlJTIwbHV4dXJ5JTIwcmV0cmVhdHxlbnwwfHx8fDE3ODI4Mzk0MjV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "03",
    title: "Mindful Stillness",
    desc: "Breathwork and meditation that create space between you and the noise of everyday life.",
    img: "https://images.unsplash.com/photo-1504548840739-580b10ae7715?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHNhbmQlMjB0ZXh0dXJlJTIwbmV1dHJhbHxlbnwwfHx8fDE3ODI4Mzk0MjV8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const Pillars = () => (
  <section id="pillars" className="py-24 md:py-32 bg-surface">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <Reveal>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-ink max-w-xl leading-[1.05]">
            Three pillars, one journey home
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-muted max-w-sm">
            Each retreat weaves these practices together into a single, restorative arc.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {pillars.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.12}>
            <div data-testid={`pillar-${i}`} className="group">
              <div className="overflow-hidden rounded-2xl aspect-[4/5] mb-6">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="flex items-baseline gap-3">
                <span className="text-clay text-sm font-sans">{p.n}</span>
                <h3 className="font-serif text-2xl text-ink">{p.title}</h3>
              </div>
              <p className="mt-3 text-muted leading-relaxed">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
